import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, SvgIcon, Typography } from '@mui/material';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../utils/getMuiIcon';

interface AiMainTopicProps {
  topic: string;
}

const AiMainTopic: React.FC<AiMainTopicProps> = ({ topic }) => {
  const { t } = useTranslation();

  if (!topic.trim()) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: spaces.xs,
        alignItems: 'center',
      }}
    >
      <SvgIcon 
        component={getMuiIcon('checkCircleFilled')} 
        sx={{ width: 16, height: 16, color: palette.primary.main }}
        data-testid='check-circle-icon'
        aria-hidden='true'  
      />
      <Typography
        variant='body2'
        data-testid='ai-main-topic-text'
        aria-label={`${t('AI suggested main topic')}: ${topic}`}
        sx={{ color: palette.text.secondary }}
      >
        {t('Topic')}{': '}<Box component='span' sx={{ fontWeight: 700 }}>{topic}</Box>
      </Typography>
    </Box>
  );
};

export default AiMainTopic;
